import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class AuthPasswordMixin extends Vue {
  isCapsLockActive = false

  checkCapsLockIsOn(event: KeyboardEvent) {
    this.isCapsLockActive = event.getModifierState('CapsLock')
  }

  destroyed() {
    document.removeEventListener('keyup', this.checkCapsLockIsOn)
  }

  mounted() {

    document.addEventListener('keyup', this.checkCapsLockIsOn)
  }
}
